import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ad815ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title_wrong_letter" }, "Неверные буквы:", -1))
const _hoisted_2 = { class: "wrapper_wrong_letters" }

import {computed} from 'vue'
import {useStore} from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'WrongLetterBlockGame',
  setup(__props) {

const store = useStore();

const wrongLetters = computed(() => { 
    return store.getters.getLetterArray.filter((x: string) => !store.getters.getWord.includes(x))
    // return store.getters.getWrongLetters.filter((item: string, index: number) => {
    //     const double = store.getters.getWrongLetters.indexOf(item) === index
    //     console.log(double)
    //     return double
    // });
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wrongLetters.value, (letter, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "wrong_letters",
          key: letter
        }, _toDisplayString(index === wrongLetters.value.length - 1 ? letter : `${letter},` + ' '), 1))
      }), 128))
    ])
  ], 64))
}
}

})